var styles = {
  "Pagination": "Polaris-Pagination"
};

export { styles as default };
